import { render } from "./tarana-resources.vue?vue&type=template&id=11c1f5dd"
import script from "./tarana-resources.vue?vue&type=script&lang=js"
export * from "./tarana-resources.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__